var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"fonte"},[_c('b',[_vm._v("Fonte:")]),_vm._v(" "+_vm._s(' e-SUS PEC, ' + _vm.ultimaAtualizacao)+" "),(_vm.texto)?_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"icon-tooltip",attrs:{"title":_vm.text}},[_c('i',{staticClass:"icofont-info-circle"})]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }